import { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { RaaExpandablePreview } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';

import { IngaendeObjektReferensIndex } from 'models';

import { SkyddstypEnum } from 'enums';

import { getIconBySkydd } from 'utilities/bebyggelseobjektUtilities';

const SammansattBebyggelseIngaendeObjektSection: FC<{
  ingaendeObject?: IngaendeObjektReferensIndex[];
  isPublicerad: boolean;
  havtSkydd?: boolean;
  skyddstyp: SkyddstypEnum;
}> = ({ ingaendeObject, isPublicerad, havtSkydd = false, skyddstyp }): ReactElement => {
  const IngaendeObjektItem = (object: IngaendeObjektReferensIndex) => {
    return (
      <div className="tw-mb-2 tw-flex tw-max-w-[85%] tw-items-center" key={object.id}>
        <img
          className="tw-mr-2 tw-h-6"
          src={`data:image/svg+xml;utf8,${encodeURIComponent(getIconBySkydd(skyddstyp, havtSkydd))}`}
          alt={`Ikon för ingående objekt`}
        />
        <li className="tw-flex tw-max-w-full tw-flex-col tw-font-semibold">
          <Link className="raa-link" to={isPublicerad ? `/bebyggelseobjekt/${object.id}` : `/utkast/${object.id}`}>
            {object.titel} <span className="tw-italic">({object.bebyggelsenummer})</span>
          </Link>
        </li>
      </div>
    );
  };

  return (
    <DrawerSection>
      <h2 className="tw-heading-md tw-mb-4">Byggnadsminnet består av {ingaendeObject?.length ?? 0} objekt</h2>
      {ingaendeObject && ingaendeObject.length > 0 && (
        <RaaExpandablePreview height={120} ariaLabel="Lista med bebyggelseutkast">
          <ul>{ingaendeObject.map(IngaendeObjektItem)}</ul>
        </RaaExpandablePreview>
      )}
    </DrawerSection>
  );
};

export default SammansattBebyggelseIngaendeObjektSection;
